"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeListResponse = makeListResponse;

var _utils = require("../../../utils");

/**
 * Simplifies the process of creating a dataserver standard list response
 * @param model
 * @param name
 * @returns {function(*=): ({}|{}|*)}
 */
function makeListResponse(model) {
  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GetFilteredRecordList';
  return function (raw) {
    return (0, _utils.parseModel)(raw, {
      result: {
        path: "".concat(name, "Result[0]"),
        model: _utils.genericAsResultHeader
      },
      totalRecordCount: {
        path: 'TotalRecordCount[0]',
        type: Number
      },
      response: {
        path: 'GenericDataSet[0].DataRow',
        model: model
      }
    });
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/lbs-pi-platform-access/es/data-server/gfrl/utils/list-response.js
// module id = 244
// module chunks = 0